module.exports = __webpack_public_path__ + "img/link_but.b6978370.svg";